import type { PermissionInfo } from './system/types';

const MAX_AGE = 30_000;
type Entry = {
	token: string;
	tenantId: string;
	expiresAt: number;
	data?: PermissionInfo;
	pending?: Promise<PermissionInfo>;
};
let entry: Entry | undefined;

// 只保存在内存，按登录令牌和租户隔离；业务接口仍逐次由后端鉴权。
export const invalidatePermissionInfo = () => {
	entry = undefined;
};

export const cachedPermissionInfo = (
	token: string,
	tenantId: string,
	load: () => Promise<PermissionInfo>
): Promise<PermissionInfo> => {
	if (entry?.token === token && entry.tenantId === tenantId) {
		if (entry.pending) return entry.pending;
		if (entry.data && Date.now() < entry.expiresAt) return Promise.resolve(entry.data);
	}
	const current: Entry = { token, tenantId, expiresAt: 0 };
	entry = current;
	current.pending = load()
		.then((info) => {
			// 登出、切换租户或权限修改后，旧请求不能恢复已清空的权限缓存。
			if (entry !== current) throw new Error('权限上下文已更新，请重新获取');
			current.data = info;
			current.expiresAt = Date.now() + MAX_AGE;
			current.pending = undefined;
			return info;
		})
		.catch((error) => {
			if (entry === current) invalidatePermissionInfo();
			throw error;
		});
	return current.pending;
};
